<app-navbar></app-navbar>

<div class="app-container">
    <!-- Sidebar -->
    <app-admin *ngIf="showLayout"></app-admin>

    <!-- Content Area -->
    <div class="content-area" [class.full-width]="!showLayout">
        <router-outlet></router-outlet>
    </div>
</div>